import React, { useState } from 'react';
import cN from 'classnames';
import * as Icons from '@components/Common/Icons/index';
import { IcommonProps } from 'src/Interface';
import styles from './styles.module.scss';

interface I_ShowProps {
    show: boolean;
    handleShowList: () => void;
}

export const OnlyArraw: React.FC<I_ShowProps> = ({ show, handleShowList }) => {
    return (
        <div className={cN(styles.iconOnly)} onClick={handleShowList}>
            <span className={cN({ [`${styles.iconOnly_up}`]: show }, styles.d_inline_block)}>
                <Icons.ArrowDown />
            </span>
        </div>
    );
};
// 因希望checkbox元件只跟父層判斷是否點擊更動狀態，並讓toggle功能分出元件

// dataIndex map出資料的目前位置，一次只顯示5筆
// dataLength 所有的資料長度，少於5筆不出現、父層最後一個element才會渲染

export const ArrawWidthText: React.FC<IcommonProps> = ({ children }) => {
    const [show, setShow] = useState(false);
    const handleShow = (e: React.MouseEvent) => {
        setShow((prev) => !prev);
    };
    return (
        <>
            {React.Children.map(children, (child, index) => {
                return index < 5 || show ? child : null;
            })}
            {React.Children.count(children) > 5 && (
                <div className={styles.More} onClick={handleShow}>
                    <span>{!show ? '顯示較多' : '顯示較少'}</span>
                    <span className={cN({ [`${styles.More_up}`]: show }, styles.d_inline_block)}>
                        <Icons.ArrowDown />
                    </span>
                </div>
            )}
        </>
    );
};
